import Vue from "vue";
import Router from "vue-router";

// import Home from "@/views/Home";
import About from "@/views/About";
import Annotator from "@/views/Annotator";
// Admin sub-pages (lazy-loaded)
var AdminLayout = function() { return import("@/views/admin/AdminLayout"); };
var UserManagement = function() { return import("@/views/admin/UserManagement"); };
var InstitutionQuotas = function() { return import("@/views/admin/InstitutionQuotas"); };
var ApiKeyManagement = function() { return import("@/views/admin/ApiKeyManagement"); };
var PrepaidManagement = function() { return import("@/views/admin/PrepaidManagement"); };
var ApiUnlimitedInstitutions = function() { return import("@/views/admin/ApiUnlimitedInstitutions"); };
import Datasets from "@/views/Datasets";
import Categories from "@/views/Categories";
import Undo from "@/views/Undo";
import TabularDataset from "@/views/TabularDataset";
import Auth from "@/views/Auth";
import User from "@/views/User";
import Dashboard from "@/views/Dashboard";
import SystemMonitor from "@/views/SystemMonitor";
import ApiKeys from "@/views/ApiKeys";
import PageNotFound from "@/views/PageNotFound";

Vue.use(Router);

var router = new Router({
  // mode: "history",
  routes: [
    {
      path: "/about",
      name: "about",
      component: About
    },
    {
      alias: "/",
      path: "/datasets",
      name: "datasets",
      component: Datasets
    },
    {
      path: "/categories",
      name: "categories",
      component: Categories
    },
    {
      path: "/undo",
      name: "undo",
      component: Undo
    },
    {
      path: "/annotate/:identifier",
      name: "annotate",
      component: Annotator,
      props: true
    },
    {
      path: "/tabulardataset/:identifier",
      name: "tabulardataset",
      component: TabularDataset,
      props: true
    },
    {
      path: "/auth",
      name: "authentication",
      component: Auth,
      props: true
    },
    {
      path: "/user",
      name: "user",
      component: User
    },
    {
      path: "/admin",
      component: AdminLayout,
      children: [
        { path: "", redirect: "users" },
        { path: "users", name: "admin-users", component: UserManagement },
        {
          path: "quotas",
          name: "admin-quotas",
          component: InstitutionQuotas,
          beforeEnter: function(to, from, next) {
            var store = require("@/store").default;
            if (store.getters["user/canViewQuotas"]) {
              next();
            } else {
              next({ name: "admin-users" });
            }
          }
        },
        {
          path: "keys",
          name: "admin-keys",
          component: ApiKeyManagement,
          beforeEnter: function(to, from, next) {
            var store = require("@/store").default;
            if (store.getters["user/canManageKeys"]) {
              next();
            } else {
              next({ name: "admin-users" });
            }
          }
        },
        {
          path: "prepaid",
          name: "admin-prepaid",
          component: PrepaidManagement,
          beforeEnter: function(to, from, next) {
            var store = require("@/store").default;
            if (store.getters["user/canManageUsers"]) {
              next();
            } else {
              next({ name: "admin-users" });
            }
          }
        },
        {
          path: "api-unlimited-institutions",
          name: "admin-api-unlimited-institutions",
          component: ApiUnlimitedInstitutions,
          beforeEnter: function(to, from, next) {
            var store = require("@/store").default;
            if (store.getters["user/canManageUsers"]) {
              next();
            } else {
              next({ name: "admin-users" });
            }
          }
        }
      ]
    },
    { path: "/admin/panel", redirect: "/admin/users" },
    {
      path: "/dashboard",
      name: "dashboard",
      component: Dashboard
    },
    {
      path: "/system",
      name: "system-monitor",
      component: SystemMonitor
    },
    {
      path: "/api-keys",
      name: "api-keys",
      component: ApiKeys
    },
    { path: "*", component: PageNotFound }
  ]
});

// Distributor 전역 라우트 가드: 웹 distributor는 허용된 페이지만, API distributor는 api-keys도 허용
var DISTRIBUTOR_ALLOWED_ROUTES = ['dashboard', 'authentication', 'user'];
var DISTRIBUTOR_API_EXTRA_ROUTES = ['api-keys'];
router.beforeEach(function(to, from, next) {
  var store = require('@/store').default;
  var user = store && store.state && store.state.user && store.state.user.user;
  if (user && user.is_distributor) {
    var allowed = DISTRIBUTOR_ALLOWED_ROUTES.indexOf(to.name) !== -1;
    // API distributor (user_type=api/both)는 api-keys 페이지도 허용
    var userType = user.user_type || 'web';
    if (!allowed && (userType === 'api' || userType === 'both')) {
      allowed = DISTRIBUTOR_API_EXTRA_ROUTES.indexOf(to.name) !== -1;
    }
    if (!allowed) {
      next({ name: 'dashboard' });
      return;
    }
  }
  next();
});

export default router;
